/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')

class CatchMethodsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { customItemClassName, catchMethods } = this.props

    return (
      <div>
        <p className="is-size-7">{`${catchMethods.map(elt => elt.name).join(', ')}...`}</p>
      </div>
    )
  }
}

CatchMethodsList.propTypes = {
  catchMethods: PropTypes.array,
  customItemClassName: PropTypes.string,
}

CatchMethodsList.defaultProps = {
  catchMethods: [],
  customItemClassName: null,
}

module.exports = CatchMethodsList
